// extracted by mini-css-extract-plugin
module.exports = {"title":"beneficiaries_title__1zBTE"};